// User Analytics Data

const userData = [
  { name: "Jan", "Active Users": 400 },
  { name: "Feb", "Active Users": 3500 },
  { name: "Mar", "Active Users": 2000 },
  { name: "Apr", "Active Users": 3000 },
  { name: "May", "Active Users": 4000 },
  { name: "Jun", "Active Users": 5000 },
  { name: "Jul", "Active Users": 4000 },
  { name: "Aug", "Active Users": 1500 },
  { name: "Sep", "Active Users": 4000 },
  { name: "Oct", "Active Users": 2800 },
  { name: "Nov", "Active Users": 3400 },
  { name: "Dec", "Active Users": 2500 },
];

// Sales Data

const salestData = [
  { name: "Jan", Sales: 3500 },
  { name: "Feb", Sales: 5500 },
  { name: "Mar", Sales: 3000 },
  { name: "Apr", Sales: 4500 },
  { name: "May", Sales: 4200 },
  { name: "Jun", Sales: 3000 },
  { name: "Jun", Sales: 5000 },
  { name: "Jul", Sales: 4000 },
  { name: "Aug", Sales: 2500 },
  { name: "Sep", Sales: 5500 },
  { name: "Oct", Sales: 2800 },
  { name: "Nov", Sales: 4800 },
  { name: "Dec", Sales: 3500 },
];

// Users Data

const userRows = [
  {
    id: 1,
    username: "Sameer Jadaun",
    desc: "Software Engineer",
    avatar: "/dashboard/images/boy.jpg",
    email: "xyz@gmail.com",
    status: "active",
    date: "25 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 2150",
  },
  {
    id: 2,
    username: "Isha Singh",
    desc: "Web Developer",
    avatar: "/dashboard/images/tshirt.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "24 Oct. 2022",
    transStatus: "declined",
    transaction: "₹ 2500",
  },
  {
    id: 3,
    username: "Emilia Peterson",
    desc: "MERN Stack Developer",
    avatar: "/dashboard/images/girl.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "23 Oct. 2022",
    transStatus: "pending",
    transaction: "₹ 1250",
  },
  {
    id: 4,
    username: "Noah Smith",
    desc: "Software Engineer",
    avatar: "/dashboard/images/manmodel.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "22 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 2530",
  },
  {
    id: 5,
    username: "Sameer Jadaun",
    desc: "Full Stack Developer",
    avatar: "/dashboard/images/boy.jpg",
    email: "xyz@gmail.com",
    status: "active",
    date: "21 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 2520",
  },
  {
    id: 7,
    username: "Arya Kaur",
    desc: "Software Engineer",
    avatar: "/dashboard/images/faceless2.jpg",
    email: "xyz@gmail.com",
    status: "active",
    date: "24 Oct. 2022",
    transStatus: "declined",
    transaction: "₹ 2500",
  },
  {
    id: 8,
    username: "Emilia Peterson",
    desc: "UI Developer",
    avatar: "/dashboard/images/girl.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "23 Oct. 2022",
    transStatus: "pending",
    transaction: "₹ 2250",
  },
  {
    id: 9,
    username: "Isha Singh",
    desc: "Software Engineer",
    avatar: "/dashboard/images/tshirt.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "23 Oct. 2022",
    transStatus: "pending",
    transaction: "₹ 2540",
  },
  {
    id: 10,
    username: "Noah Smith",
    desc: "Full Stack Developer",
    avatar: "/dashboard/images/manmodel.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "22 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 1500",
  },
  {
    id: 11,
    username: "Arya Kaur",
    desc: "Software Engineer",
    avatar: "/dashboard/images/faceless2.jpg",
    email: "xyz@gmail.com",
    status: "active",
    date: "22 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 1250",
  },
  {
    id: 12,
    username: "Emilia Peterson",
    desc: "Software Engineer",
    avatar: "/dashboard/images/girl.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "24 Oct. 2022",
    transStatus: "declined",
    transaction: "₹ 3250",
  },
  {
    id: 13,
    username: "Noah Smith",
    desc: "Full Stack Developer",
    avatar: "/dashboard/images/manmodel.webp",
    email: "xyz@gmail.com",
    status: "active",
    date: "22 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 7250",
  },
  {
    id: 14,
    username: "Sameer Jadaun",
    desc: "Software Engineer",
    avatar: "/dashboard/images/boy.jpg",
    email: "xyz@gmail.com",
    status: "active",
    date: "22 Oct. 2022",
    transStatus: "approved",
    transaction: "₹ 2150",
  },
];

// Products Data

const productRows = [
  {
    id: 1,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2510",
  },
  {
    id: 2,
    productName: "Jacket",
    img: "/dashboard/images/girl.webp",
    stock: 52,
    status: "active",
    price: "₹ 2500",
  },
  {
    id: 3,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2450",
  },
  {
    id: 4,
    productName: "Jacket",
    img: "/dashboard/images/girl.webp",
    stock: 52,
    status: "active",
    price: "₹ 2505",
  },
  {
    id: 5,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2550",
  },
  {
    id: 7,
    productName: "Jacket",
    img: "/dashboard/images/girl.webp",
    stock: 52,
    status: "active",
    price: "₹ 2590",
  },
  {
    id: 8,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2530",
  },
  {
    id: 9,
    productName: "Jacket",
    img: "/dashboard/images/girl.webp",
    stock: 52,
    status: "active",
    price: "₹ 2520",
  },
  {
    id: 10,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2510",
  },
  {
    id: 11,
    productName: "Jacket",
    img: "/dashboard/images/girl.webp",
    stock: 52,
    status: "active",
    price: "₹ 2520",
  },
  {
    id: 12,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2750",
  },
  {
    id: 13,
    productName: "Jacket",
    img: "/dashboard/images/girl.webp",
    stock: 52,
    status: "active",
    price: "₹ 2150",
  },
  {
    id: 14,
    productName: "T-Shirts",
    img: "/dashboard/images/tshirt.webp",
    stock: 52,
    status: "active",
    price: "₹ 2250",
  },
];

export { userData, salestData, userRows, productRows };
